import { useMetaTags } from 'react-metatags-hook';
import { MetaTagsConfig } from 'react-metatags-hook/dist/cjs/types';
import { buildPublicUrl } from './buildUrl';
import { sanitizeText } from './strEscape';

const DEFAULT_TITLE = 'Ищите новые идеи от любимых брендов по картинкам — Яндекс Ритм';

const DEFAULT_EXTERNAL_TITLE = 'Яндекс Ритм';

const DEFAULT_DESCRIPTION = `Ритм позволяет следить за любимыми брендами или просто искать вдохновение — например, идеи для стиля или для ремонта в квартире.

Чтобы купить товар «как на картинке», больше не нужно искать в интернете — достаточно перейти по ссылке в посте. Находите идеи и товары по темам, которые вам интересны, от моды до спорта.`;

export const useMeta = (config: MetaTagsConfig = {}, dependencies: unknown[] = []) => {
    const sanitizedTitle =
        sanitizeText({ text: config.title?.replace(/['"]/g, '') }) || DEFAULT_TITLE;
    const sanitizedDescription = sanitizeText({ text: config.description }) || DEFAULT_DESCRIPTION;

    const openGraphConfig = config.openGraph || {};
    const sanitizedOpenGraphTitle = sanitizeText({ text: openGraphConfig.title }) || sanitizedTitle;
    const sanitizedOpenGraphDescription =
        sanitizeText({ text: openGraphConfig.description }) || sanitizedDescription;

    const twitterConfig = config.twitter || {};
    const sanitizedTwitterTitle =
        sanitizeText({ text: twitterConfig.title }) || sanitizedOpenGraphTitle;
    const sanitizedTwitterDescription =
        sanitizeText({ text: twitterConfig.description }) || sanitizedOpenGraphDescription;

    const metas = config.metas || [];

    return useMetaTags(
        {
            title: sanitizedTitle,
            description: sanitizedDescription,
            openGraph: {
                site_name: DEFAULT_EXTERNAL_TITLE,
                title: sanitizedOpenGraphTitle,
                image: openGraphConfig.image || buildPublicUrl('/images/og-image.png'),
                description: sanitizedOpenGraphDescription,
            },
            twitter: {
                card: 'summary_large_image',
                title: sanitizedTwitterTitle,
                description: sanitizedTwitterDescription,
                image:
                    twitterConfig.image ||
                    openGraphConfig.image ||
                    buildPublicUrl('/images/og-image.png'),
            },
            links: Array.isArray(config.links)
                ? config.links.map((link) => ({
                      ...link,
                      href: sanitizeText({ text: link.href }),
                  }))
                : [],
            metas,
        },
        dependencies,
    );
};
